import React from 'react';
import './ProductCatagories.css';
import { Link } from "react-router-dom";
import Domestic from './img6.jpg'
const ProductCategories = () => {
  return (
    <div className="mainHome-container1">

        <div className="ALLOYMETALS-herosection" >
            <div className="MixedMETALS-herosection-pic">
                <div className="ALLOYMETALS-herosection-heading">
                    HOME / Specialty & Mixed Scrap
                </div>
            
            </div>
            
        </div>
        <div className="Each-Product-container" >
        

            <div className="Each-Product-mid-left-container">
                <div className='Each-Product-tittle'>
                Specialty & Mixed Scrap
                </div>
                <div className='Each-Product-mid-details'>
                Our ferrous metal scrap products, containing iron and magnetic properties, are ideal for construction, manufacturing, and infrastructure projects. These materials ensure durability, versatility, and sustainability, supporting various industrial applications while promoting eco-friendly practices through efficient recycling and resource utilization.
                                </div>
            </div>
            <div className="Each-Product-mid-right-container">
                <div className="tranding-pics">
                    <img src={Domestic} alt="" className='tranding-left-pics' />
                </div>

            </div>
        </div>
    <section className="Each-Product-Details-card" style={{height:"auto", paddingBottom:"50px"}}>
      <h2>Import Scrap</h2>
      
      <section className="product-categories-list">
      <div className="product-categories-list-header">
        
      </div>

      <div className="product-categories-list-grid">
        {productCategoryDetails.map((productCategory, index) => (
          <div key={index} className="product-categories-list-box">
            <div className="Each-product-benifitt-icon"><img src={productCategory.image} alt={productCategory.image} className='Each-Product-Details-card-img'/></div>
            <h3>{productCategory.title}</h3>
            <p>{productCategory.description}</p>
          </div>
        ))}
      </div>
    </section>
      {/* <button className="view-button">View All Products</button> */}
      {/* <h2 className='Product-category-title'>Browse by Category</h2> */}
    </section>
    
    </div>
  );
};

export default ProductCategories;

const productCategoryDetails = [
  {
    title: "Mixed Metal Scrap",
    description: "A combination of different metals, often from industrial waste or construction, suitable for those who require diverse materials for processing.",
    image: "/Products/Mixed/1.jpg"
  },
  {
    title: "Stainless Steel Scrap",
    description: "Stainless steel is a key material in industries such as automotive, manufacturing, and construction. We offer high-quality stainless steel scrap in various grades.",
    image: "/Products/Mixed/2.jpg"
  },


    
  ];
  